export const environment = {
  mode: 'production',
  version: '1.5.5',
  coreVersion: '7.3.11',
  production: true,
  pwa: false,
  bundleId: 'com.namsoftware.smartbot',
  name: 'Smart-BOT',
  title: 'App vận hành nội bộ thuộc ProBox One',
  copyright: 'Copyright ProBox năm 2017',
  api: {
    defaultUrl: 'https://user.probox.vn/v3/users',// check
    version: 'v4'
  },
  authentication: {
    notLoggedInUrl: '/recent-logins',
  },
  notification: {
    senderId: 316262946834,
  },
  tokenStorageKey: 'jwt-token',
  deployment: {
    ios: {
      baseBuild: 392,
      key: 'o42s6NQINffaNrRK8VhWcpygDwkgpPsZlz1cc',
    },
    android: {
      baseBuild: 375,
      key: 'xrTYGssFkYhFqLw842GR5dVbiVL8NOXPXQ_mJ',
    },
  },
  google: {
    maps: {
      apiKey: 'AIzaSyDjQl1YsJdrESCyYpxIXTFs7oTiL1nxKY8',
    },
  },
  chat: {
    requireLocation: true
  }
};
